export default __webpack_public_path__ + "static/media/hatdummy.9b16d402.png";